import {ApplicationConfig, provideZoneChangeDetection} from '@angular/core';
import {ENV, FIREBASE_APP, FIREBASE_AUTH, FIREBASE_DATABASE, FIREBASE_STORAGE, FIRESTORE} from './module.di.tokens';
import {environment} from '../../environments/environment';
import {getFirestore} from '@firebase/firestore';
import {getAuth} from '@firebase/auth';
import {getStorage} from '@firebase/storage';
import {getDatabase} from '@firebase/database';
import {provideIndexedDb} from 'ngx-indexed-db';
import {indexeddbConfig} from './indexeddb.config';
import {provideHttpClient, withInterceptors} from '@angular/common/http';
import {authInterceptor} from '../../common/interceptor/auth.interceptor';
import {initializeApp} from '@firebase/app';
import {provideClientHydration} from '@angular/platform-browser';
import {provideRouter, withComponentInputBinding, withInMemoryScrolling, withRouterConfig} from '@angular/router';
import {routes} from '../routes/app.routes';

export const firebaseApp = initializeApp(environment.firebase)
export const commonConfig: ApplicationConfig = {
  providers: [
    {provide: ENV, useValue: environment.remoteApi ? 'prd' : 'dev'},
    {provide: FIREBASE_APP, useValue: firebaseApp},
    {provide: FIRESTORE, useFactory: () => getFirestore(firebaseApp, environment.firestoreDatabase)},
    {provide: FIREBASE_AUTH, useFactory: () => getAuth(firebaseApp)},
    {provide: FIREBASE_STORAGE, useFactory: () => getStorage(firebaseApp)},
    {provide: FIREBASE_DATABASE, useFactory: () => getDatabase(firebaseApp)},
    provideIndexedDb(indexeddbConfig),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideHttpClient(
      withInterceptors([authInterceptor])
    ),
    provideClientHydration(),
    provideRouter(routes,
      withInMemoryScrolling({
        scrollPositionRestoration: 'top',
        anchorScrolling: 'disabled',
      }),
      withComponentInputBinding(),
      withRouterConfig({
        paramsInheritanceStrategy: 'always'
      })
    )
  ]
}
